import { Injectable, isDevMode } from '@angular/core';

@Injectable()
export class SharedService {

  private franchiseServerUrl: string = isDevMode() ? 'https://uat.skypoint.online/api/service/' : 'https://skypoint.online/api/service/';

  private payFastUrl = isDevMode() ? 'https://sandbox.payfast.co.za/eng/process' : 'https://www.payfast.co.za/eng/process';

  private peachPaymentUrl = isDevMode() ? 'https://testsecure.peachpayments.com' : 'https://secure.peachpayments.com';

  public getPayFastUrl(): string {
    return this.payFastUrl;
  }

  public getFranchiseUrl(): string {
    return this.franchiseServerUrl;
  }

  public getPeachUrl(): string {
    return this.peachPaymentUrl;
  }
}
